import { useLocale } from '../context/DynamicLocaleProvider';
import { GlobalMicroButton } from './GlobalMicroButton';
import { EmptyStateGraphic } from './EmptyStateGraphic';
import styles from './GlobalEmptyState.module.css';

interface GlobalEmptyStateProps {
  title?: string;
  description?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  buttonIcon?: React.ReactNode;
}

export default function GlobalEmptyState({
  title,
  description,
  buttonText,
  onButtonClick,
  buttonIcon,
}: GlobalEmptyStateProps) {
  const { t } = useLocale();

  return (
    <div className={styles.emptyState}>
      <EmptyStateGraphic />
      <h4 className={styles.title}>{title ?? t('global_empty_state_title')}</h4>
      <p className={styles.description}>{description ?? t('global_empty_state_description')}</p>
      {buttonText && onButtonClick && (
        <GlobalMicroButton
          onClick={onButtonClick}
          icon={buttonIcon}
        >
          {buttonText}
        </GlobalMicroButton>
      )}
    </div>
  );
}
